// src/page/Home/Home.js
import React from 'react';

import FIrsstHomePageBanner from '../../Components/FirstHomePageBanner/FIrsstHomePageBanner';
import './Home.css';
import Header from '../Header/Header';
import FileManager from '../../Components/FileManager/FileManager';

// ✅ Role hook (path matches: src/hooks/useAuthRole.js)
import useAuthRole from '../../Components/Hooks/useAuthRole';

// Roles that ARE allowed to see the Home + FileManager page.
// We allow all department "new_*" roles, department roles, and elevated roles.
// Only "new_register" (or unknown roles) will see the pending-authorization modal.
const ALLOWED_ROLES = [
  // Onboarding department roles
  'new_sales',
  'new_production',
  'new_finance',
  'new_hr',
  'new_administrative',

  // Regular / active roles
  'user',
  'sales',
  'production',
  'finance',
  'hr',
  'administrative',

  // Elevated roles
  'operator',
  'moderator',
  'admin',
];

const Home = () => {
  const { role, isLoading } = useAuthRole();
  const normalizedRole = String(role || '').toLowerCase();
  const canView = ALLOWED_ROLES.includes(normalizedRole);

  if (isLoading) {
    return (
      <div className="home-loading-root d-flex justify-content-center align-items-center">
        <div
          className="spinner-border text-primary home-loading-spinner"
          role="status"
          aria-live="polite"
        >
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (canView) {
    return (
      <div className="home-root">
        <Header />
        <main className="home-main">
          {/* Banner / hero section */}
          <section className="home-banner-section" id="home">
            <div className="home-banner-inner">
              <FIrsstHomePageBanner />
            </div>
          </section>

          {/* File manager section */}
          <section className="home-filemanager-section">
            <div className="container-fluid home-filemanager-container">
              <FileManager />
            </div>
          </section>
        </main>
      </div>
    );
  }

  // new_register or any unknown role → show pending authorization message
  return (
    <>
      <div className="home-auth-root">
        <div
          className="modal fade show home-auth-modal"
          role="dialog"
          aria-modal="true"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog modal-dialog-centered home-auth-dialog">
            <div className="modal-content shadow home-auth-content">
              <div className="modal-header home-auth-header">
                <h5 className="modal-title home-auth-title">
                  Authorization Required
                </h5>
              </div>
              <div className="modal-body home-auth-body">
                <p className="mb-0">
                  Your account is pending authorization.
                  <br />
                  <strong>
                    Contact with the Admin for authorization access.
                  </strong>
                </p>
              </div>
              <div className="modal-footer home-auth-footer">
                <a
                  href="/"
                  className="btn btn-secondary home-auth-btn"
                >
                  Go to Login
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Backdrop */}
        <div className="modal-backdrop fade show home-auth-backdrop" />
      </div>
    </>
  );
};

export default Home;
